import { format } from 'date-fns';

export const RouteNav = {
  dayView: (date?: Date, tab?: string) =>
    `/app/day/${date ? format(date, 'yyyy-MM-dd') : ''}${tab ? `#${tab}` : ''}`,
};

export default RouteNav;
